import { IEnvConfigUtils } from "Interfaces/Utils/IEnvConfigUtils";
import * as React from "react";
import { connect } from "react-redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IAuthenticationState } from "Store/Authentication/AuthenticationActionTypes";
import { IApplicationState } from "Store/Store";

const envConfigUtils = ServiceProvider.get<IEnvConfigUtils>(Types.IEnvConfigUtils);

const mapStateToProps = (state: IApplicationState) => ({
    authenticationState: state.authenticationState
});

interface IProps {
    externalPath: string;
    authenticationState: IAuthenticationState;
}

interface IState {
    authenticationState: IAuthenticationState;
}

export class RedirectToCMS extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            authenticationState: props.authenticationState
        };
    }

    private redirect() {
        const cmsUrl = envConfigUtils.getEnvVariables().cmsUrl;
        let url = cmsUrl + this.props.externalPath;
        const login = this.state.authenticationState.login;
        if (login && login.user.role === "superuser") {
            url += `/company/${login.companyId}`;
        }

        window.location.href = url;
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState | null> {
        if (nextProps.authenticationState !== prevState.authenticationState) {
            return { authenticationState: nextProps.authenticationState };
        }
        return null;
    }

    public render() {
        this.redirect();
        return null;
    }
}

export default connect(mapStateToProps)(RedirectToCMS);


// WEBPACK FOOTER //
// ./src/Components/Redirect/RedirectToCMS.ts